import mixins from 'vue-typed-mixins'
import * as _ from 'lodash'
import { mapGetters } from 'vuex'
import UserActionMixin from '@/mixins/UserActionMixin'
import MediaModalMixin from './MediaModalMixin'

export default mixins(MediaModalMixin, UserActionMixin).extend({
  computed: {
    ...mapGetters('Chat', ['imagePurchasePoint', 'videoPurchasePoint']),

    $_isMan(): boolean {
      return this.$store.getters['MyData/isMan']
    }
  },
  methods: {
    /**
     * メディアファイル を Click
     */
    async $_handleMediaClick(
      entry: any,
      timestamp: string,
      userId: string,
      savePoint: string
    ): Promise<any> {
      const type = _.get(entry, 'message.attachment.type')
      if (!type) {
        return
      }

      // メッセージギャラリーには speaker が無く相手のファイルだけ表示されるので
      const speakerIsOther =
        _.get(entry, 'message.speaker') === 'other' || this.$route.name === 'mfgallery'
      const isPurchased = this.$_isPurchased(type, entry)
      const needsBuy = this.$_isMan && speakerIsOther && !isPurchased

      if (needsBuy) {
        const point = this.$_buyPoint(type)
        const typeLabel = type === 'photo' ? '写真' : type === 'video' ? '動画' : ''
        const buttonIndex = await this.$_confirm(
          `${point}ptsを使ってこの${typeLabel}をみますか？`,
          `${typeLabel}の閲覧`,
          ['キャンセル', `${typeLabel}を見る`]
        )
        if (!this.$_clickedConfirmOK(buttonIndex)) return

        return await this.$_buyFile({
          id: entry.message.id,
          timestamp: timestamp,
          type: type
        })
      } else {
        const mediaModalParams = {
          mediaUrl: _.get(entry, `message.attachment.${type}.media_url`),
          mediaThumbnail: _.get(entry, `message.attachment.${type}.thumbnail_url`),
          mediaType: type,
          savePhotoPoint: savePoint,
          saveVideoPoint: savePoint,
          requestUrl: '/message/',
          requestParams: {
            other_id: userId,
            id: entry.message.id
          }
        }
        this.$_showMediaModal(mediaModalParams)
      }
    },

    /**
     * ファイルの購入処理
     */
    async $_buyFile(payload): Promise<any> {
      try {
        const data = await this.$store.dispatch('Chat/buy', {
          page: 'buy',
          id: payload.id
        })
        const error = _.get(data, 'entries.message.error', '')
        if (error) return error

        // 購入済みに変更
        data.entries.message.attachment[payload.type].is_purchased = true

        return {
          timestamp: payload.timestamp,
          entries: data.entries
        }
      } catch (err) {
        // 購入失敗
        if (err.message === 'ポイントエラー') {
          await this.$_showPointBuyDialog(err.description, err.message)
        }
      }
    },

    /**
     * message オブジェクトから添付ファイルの購入フラグを取得する
     */
    $_isPurchased(type: 'photo' | 'video', entry: any): boolean {
      return type === 'photo'
        ? _.get(entry, 'message.attachment.photo.is_purchased')
        : type === 'video'
        ? _.get(entry, 'message.attachment.video.is_purchased')
        : false
    },

    /**
     * 購入ポイント
     */
    $_buyPoint(type: 'photo' | 'video'): string {
      return type === 'photo'
        ? this.imagePurchasePoint
        : type === 'video'
        ? this.videoPurchasePoint
        : ''
    },

    /**
     * 入力途中のテキストを取得
     */
    $_getInputtingTexts(key: string): string {
      const InputtingTexts = JSON.parse(sessionStorage.getItem('InputtingTexts')) || {}
      return InputtingTexts[key]
    },

    /**
     * 入力途中のテキストをキャッシュ
     */
    $_saveInputtingTexts(key: string, text: string) {
      const InputtingTexts = JSON.parse(sessionStorage.getItem('InputtingTexts')) || {}
      if (text) {
        InputtingTexts[key] = text
      } else {
        delete InputtingTexts[key]
      }
      sessionStorage.setItem('InputtingTexts', JSON.stringify(InputtingTexts))
    }
  }
})
